export const variantKey = (size = "", color = "") => `${size || ""}|${color || ""}`;

export const tracksVariants = (p) => !!(p?.variant_stock && Object.keys(p.variant_stock).length);

export function variantAvailable(p, size = "", color = "") {
  if (!p) return 0;
  if (!tracksVariants(p)) return Number(p.stock ?? 0);
  const vs = p.variant_stock;
  const key = variantKey(size, color);
  if (key in vs) return Number(vs[key]);
  return Object.entries(vs).reduce((sum, [k, v]) => {
    const [s, c] = k.split("|");
    const sizeOk = !size || s === size;
    const colorOk = !color || c === color;
    return sizeOk && colorOk ? sum + Number(v) : sum;
  }, 0);
}

export const sizeInStock = (p, size, color = "") => variantAvailable(p, size, color) > 0;
export const colorInStock = (p, color, size = "") => variantAvailable(p, size, color) > 0;

export function firstAvailable(p) {
  const sizes = p?.sizes?.length ? p.sizes : [""];
  const colors = p?.colors?.length ? p.colors : [""];
  for (const c of colors) for (const s of sizes) if (variantAvailable(p, s, c) > 0) return { size: s, color: c };
  return { size: sizes[0], color: colors[0] };
}

export const cartLabel = (size, color) => `${size || ""}${color ? (size ? " · " : "") + color : ""}`;
